(function($) {
  var reorder = {
    pushQueue: function(i, data, $btn) {
      // 根据库存和需求调整数量 Adjust the quantity according to inventory
      if(data[i].check_inventory) {
        data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
        if(data[i].quantity <= 0) {
          // 库存为0直接跳过此商品 Skip the item if it is 0 stock
          reorder.pushQueue(i + 1, data, $btn);
          return;
        }
      }

      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        dataType: 'json',
        data: {
          id: data[i].id,
          quantity: data[i].quantity
        },
        success: function() {
          if(i >= data.length - 1) {
            $btn.removeClass('loading').prop('disabled', false);
            window.location.href = '/cart';
          } else {
            reorder.pushQueue(i + 1, data, $btn);
          }
        },
        error: function(xhr) {
          console.error('Failed to add variant ' + data[i].id, xhr);
          // 继续尝试添加下一个 continue trying next
          if(i >= data.length - 1) {
            $btn.removeClass('loading').prop('disabled', false);
            window.location.href = '/cart';
          } else {
            reorder.pushQueue(i + 1, data, $btn);
          }
        }
      });
    },

    onClick: function(e) {
      e.preventDefault();
      var $btn = $(this);

      if($btn.hasClass('loading')) return; // 防止重复点击 Prevent duplicate clicks
      $btn.addClass('loading').prop('disabled', true);

      var ids = $btn.data('variant-ids').toString().split(',');
      var quantities = $btn.data('variant-quantities').toString().split(',');
      var inventories = $btn.data('variant-inventories').toString().split(',');
      var inventoryPolicies = $btn.data('variant-inventory-policies').toString().split(',');
      var inventoryTrackers = $btn.data('variant-inventory-trackers').toString().split(',');

      // 清除最后可能多余的空字符串 Clear empty strings
      if(ids[ids.length - 1] === '') ids.pop();
      if(quantities[quantities.length - 1] === '') quantities.pop();
      if(inventories[inventories.length - 1] === '') inventories.pop();
      if(inventoryPolicies[inventoryPolicies.length - 1] === '') inventoryPolicies.pop();
      if(inventoryTrackers[inventoryTrackers.length - 1] === '') inventoryTrackers.pop();

      var data = [];
      for(var i = 0; i < ids.length; i++) {
        data.push({
          id: ids[i],
          quantity: quantities[i],
          inventory: inventories[i],
          check_inventory: (inventoryPolicies[i] === 'deny' && inventoryTrackers[i] !== '')
        });
      }

      reorder.pushQueue(0, data, $btn);
    },

    init: function() {
      $(document).on('click', '.reorder-btn', reorder.onClick);
    }
  };

  $(function() {
    reorder.init();
  });
})(jQuery);